export default {
  form: {
    country: {
      label: 'País',
      placeholder: 'Selecionar país',
    },
  },
};
